import { Box, Stack } from '@mui/material'
import { MillimeterField } from '@ui/forms'

// Crop margins (bu/bb/bl/br) of a PDF that is merged into the document
const CropMarginFields = () => (
  <Stack spacing={2}>
    <Stack direction="row" spacing={1}>
      <Box sx={{ maxWidth: 200 }}>
        <MillimeterField name="bu" placeholder="40" label="Rand oben" />
      </Box>
      <Box sx={{ maxWidth: 200 }}>
        <MillimeterField name="bb" placeholder="40" label="Rand unten" />
      </Box>
    </Stack>

    <Stack direction="row" spacing={1}>
      <Box sx={{ maxWidth: 200 }}>
        <MillimeterField name="bl" placeholder="40" label="Rand links" />
      </Box>
      <Box sx={{ maxWidth: 200 }}>
        <MillimeterField name="br" placeholder="40" label="Rand rechts" />
      </Box>
    </Stack>
  </Stack>
)

export default CropMarginFields
